module.exports = require('./helpers/bundle-url').getBundleURL('hdhZv') + "blisspro-webfont.96d7164d.woff2";